/**
 * Warehouse + place search for CostcoChase (Photon geocoder, str-regs inspired).
 */

const PHOTON_API = 'https://photon.komoot.io/api/';

export function filterWarehouses(warehouses, query) {
	const q = String(query || '').trim().toLowerCase();
	if (!q) return warehouses || [];
	return (warehouses || []).filter((w) => {
		const hay = `${w.name} ${w.city || ''} ${w.state_code || ''} ${w.address || ''}`.toLowerCase();
		return hay.includes(q);
	});
}

export function rankWarehousesByDistance(warehouses, lat, lng) {
	if (!Number.isFinite(lat) || !Number.isFinite(lng)) return warehouses || [];
	return [...(warehouses || [])].sort((a, b) => {
		const da = (a.lat - lat) ** 2 + (a.lng - lng) ** 2;
		const db = (b.lat - lat) ** 2 + (b.lng - lng) ** 2;
		return da - db;
	});
}

/**
 * @param {string} query
 * @param {{ lat?: number, lng?: number }} [bias]
 */
export async function fetchPlaceSuggestions(query, bias = {}) {
	const q = String(query || '').trim();
	if (q.length < 2) return [];
	const params = new URLSearchParams({ q, limit: '6', lang: 'en' });
	params.set('osm_tag', '!place:country');
	params.set('osm_tag', '!place:continent');
	if (Number.isFinite(bias.lat) && Number.isFinite(bias.lng)) {
		params.set('lat', String(bias.lat));
		params.set('lon', String(bias.lng));
	}
	const res = await fetch(`${PHOTON_API}?${params}`, {
		signal: AbortSignal.timeout(2500),
	});
	if (!res.ok) return [];
	const data = await res.json();
	return (data.features || [])
		.map((f) => {
			const [lng, lat] = f.geometry?.coordinates || [];
			const p = f.properties || {};
			const label = [p.name, p.city, p.state].filter(Boolean).join(', ');
			if (!label || !Number.isFinite(lat)) return null;
			return { label, lat, lng, kind: 'place' };
		})
		.filter(Boolean);
}

export function nearestWarehouse(warehouses, lat, lng, maxMiles = 80) {
	const ranked = rankWarehousesByDistance(warehouses, lat, lng);
	const best = ranked[0];
	if (!best) return null;
	const dLat = (best.lat - lat) * 69;
	const dLng = (best.lng - lng) * 54;
	const miles = Math.sqrt(dLat * dLat + dLng * dLng);
	if (miles > maxMiles) return null;
	return { warehouse: best, miles };
}

export function requestUserLocation() {
	return new Promise((resolve, reject) => {
		if (!navigator?.geolocation) {
			reject(new Error('Geolocation not supported'));
			return;
		}
		navigator.geolocation.getCurrentPosition(
			(pos) => resolve({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
			(err) => reject(err),
			{ enableHighAccuracy: false, timeout: 12000, maximumAge: 300000 },
		);
	});
}
